define('home/views/OnboardingView',[
    'jquery',
    'handlebars',
    'underscore',
    'backbone-marionette',

    'core/constants/exploreModuleConstants',
    'core/utils/url/parseQueryString',
    'core/UniqueModel',

    'home/mixins/withOnboarding',

    'home/models/Session',
    'home/models/Forum',

    'home/views/CompleteOnboardingView',
    'home/views/ExploreChannelGroupsView',
    'home/templates/onboarding',
], function (
    $,
    Handlebars,
    _,
    Marionette,

    exploreModuleConstants,
    parseQueryString,
    UniqueModel,

    withOnboarding,

    Session,
    Forum,

    CompleteOnboardingView,
    ExploreChannelGroupsView,
    onboardingTemplate
) {
    'use strict';

    var OnboardingView = Marionette.Layout.extend({
        className: 'is-onboard-welcome',
        template: onboardingTemplate,
        templateHelpers: function () {
            var numTotalSteps = this.constructor.NUM_STEPS;
            return {
                numTotalSteps: numTotalSteps,
                numRemainingSteps: Math.max(numTotalSteps - this.getStepNumber() + 1, 0),
                emailVerified: Boolean(parseQueryString().email_verified),
                canSkip: this.userCanSkip(),

                // this.user isn't set until session loads
                sessionUser: this.user && this.user.toJSON(),
            };
        },

        regions: {
            exploreRegion: '[data-role=explore]',
            overlayRegion: '[data-role=overlay]',
        },

        ui: {
            bannerWrapper: '[data-role=banner-wrapper]',
            fixedBanner: '[data-role=fixed-banner]',
        },

        events: {
            'click [data-action=finish]': 'showCompleteOverlay',
            'click [data-action=hide-welcome]': 'hideWelcomeOverlay',
        },

        initialize: function (options) {
            options = options || {};
            this.channelId = options.channelId;
            this.initForum();

            this.session = Session.get();
            this.session.loadPromise().then(_.bind(function () {
                this.user = this.session.user;
                this.render();
            }, this));

            this.listenTo(this, 'change:stepNumber', this.updateBanners);

            this.onScroll = _.bind(this.onScroll, this);
            $(window).on('scroll', this.onScroll);
        },

        onClose: function () {
            $(window).off('scroll', this.onScroll);
        },

        initForum: function () {
            var forumId = parseQueryString().forum_id;

            if (forumId) {
                this.forum = new UniqueModel(Forum, { id: forumId });

                if (this.forum.shouldFetch()) {
                    this.forum.fetch().always(_.bind(this.handleWelcome, this));
                    return;
                }
            }

            this.handleWelcome();
        },

        onScroll: _.debounce(function () {
            var showFixedBanner = $(window).scrollTop() >= this.bannerBottom;
            this.ui.fixedBanner.toggleClass('is-visible', showFixedBanner);
        }, 100),

        updateBanners: function () {
            var data = this.serializeData();
            this.mixinTemplateHelpers(data);
            this.ui.bannerWrapper.html(Handlebars.partials.onboardingBanner(data));

            this.ui.bannerWrapper.toggleClass('is-complete', !data.numRemainingSteps);
            this.ui.fixedBanner.toggleClass('is-complete', !data.numRemainingSteps);
        },

        onDomRefresh: function () {
            var channelGroupTabs = exploreModuleConstants.TABS;

            this.collection.ensureFetched();
            this.exploreRegion.show(new ExploreChannelGroupsView({
                collection: this.collection,
                activeTab: this.channelId,
                channelTabs: [channelGroupTabs.TOP],

                // When in onboarding, the only top level tab available to
                // explore is channels (not discussions or people).
                exploreTab: 'channels',
            }));

            this.bannerBottom = this.ui.bannerWrapper.outerHeight();
        },

        /**
         * If the user arrived from the embed, an overlay is shown with a message
         * including the referring forum. The user must click to close this overlay.
         *
         * If there is no referring forum, or after the user clicks to close the
         * overlay, the page transitions through a time-based welcome animation
         * controlled by class changes.
         */
        handleWelcome: function () {
            if (!this.forum) {
                this.beginWelcomeAnimation();
                return;
            }

            this.overlayRegion.ensureEl();
            this.overlayRegion.$el
                .removeClass('is-hidden')
                .html(Handlebars.partials.welcomeOverlay({
                    forum: this.forum.toJSON(),
                }));
        },

        showCompleteOverlay: function () {
            var completeOnboardingView = new CompleteOnboardingView();
            this.listenTo(completeOnboardingView, 'complete', this.completeOnboarding);

            this.overlayRegion.show(completeOnboardingView);
            this.overlayRegion.$el.removeClass('is-hidden');
        },

        hideWelcomeOverlay: function () {
            this.overlayRegion.ensureEl();
            this.overlayRegion.$el.addClass('is-hidden');
            this.beginWelcomeAnimation();
        },

        beginWelcomeAnimation: function () {
            _.delay(
                _.bind(this.$el.removeClass, this.$el, 'is-onboard-welcome'),
                this.constructor.WELCOME_MESSAGE_DURATION
            );
        },
    }, {
        WELCOME_MESSAGE_DURATION: 2000,
    });

    withOnboarding.call(OnboardingView.prototype);

    return OnboardingView;
});

